const toHex = (num) => {
  return "0x" + num.toString(16);
};

export const fetcher = (...args) => fetch(...args).then((res) => res.json());

export const addNetwork = (account, chain, rpc) => {
  if (!account) {
    return;
  }
  const params = {
    chainId: toHex(chain.chainId),
    chainName: chain.name,
    nativeCurrency: {
      name: chain.nativeCurrency.name,
      symbol: chain.nativeCurrency.symbol,
      decimals: chain.nativeCurrency.decimals,
    },
    rpcUrls: rpc ? [rpc] : chain.rpc,
    blockExplorerUrls: [
      chain.explorers && chain.explorers.length > 0 && chain.explorers[0].url
        ? chain.explorers[0].url
        : chain.infoUrl,
    ],
  };

  window.ethereum
    ?.request({
      method: "wallet_addEthereumChain",
      params: [params],
    })
    .then((result) => {})
    .catch((error) => {
      console.log(error);
    });
};
